import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { version } from '@version';
import { AppSettingsQuery } from 'chronos-shared';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  public disabledWorkCenter: boolean;

  constructor(public appSettingsQuery: AppSettingsQuery, private translateService: TranslateService) {}

  public version = version;
  public isProductionEnvironment$: Observable<boolean>;
  public applicationName: string;

  public ngOnInit(): void {
    this.isProductionEnvironment$ = this.appSettingsQuery.isProductionEnvironment$;

        this.appSettingsQuery.isPackagramLogoEnabled$.subscribe((isEnabled) => {
        this.applicationName = isEnabled
        ? this.translateService.instant('APP.BASEDATA_APPLICATION')
        : this.translateService.instant('APP.MM_BASEDATA_APPLICATION');
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
